import { inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';

import { of, switchMap } from 'rxjs';

import {
  BasicVerificationStatus,
  IDVerificationStatus,
} from '../models/verification-profile-response';
import { SummaryVerificationFacade } from '../state/facades/summary';

const routes = {
  auto: '/profile/verification/express/auto',
  email: '/profile/verification/express/email',
  dashboard: '/dashboard',
};

export const ExpressGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  { url }: RouterStateSnapshot,
) => {
  const facade = inject(SummaryVerificationFacade);
  const router = inject(Router);

  return facade.summary$.pipe(
    switchMap((summary) => {
      if (
        summary.basicStatus === BasicVerificationStatus.none &&
        summary.idStatus !== IDVerificationStatus.banned
      ) {
        return of(url === routes.auto || router.createUrlTree([routes.auto]));
      } else if (
        summary.basicStatus === BasicVerificationStatus.basicFormPassed &&
        summary.idStatus !== IDVerificationStatus.banned
      ) {
        return of(url === routes.email || router.createUrlTree([routes.email]));
      }
      return of(router.createUrlTree([routes.dashboard]));
    }),
  );
};
